import { IAMAccountEffects } from "./iam-account.effects";
import { IAMAccountsEffects } from "./iam-accounts.effects";

export { IAMAccountEffects, IAMAccountsEffects };

export default [IAMAccountEffects, IAMAccountsEffects];
